export default __webpack_public_path__ + "static/media/Pause-Button.8effcc3a.svg";